var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FrField',{attrs:{"label":"Bucket Search","field":_vm.field,"type":"multiselect"},on:{"search-change":_vm.handleSearch},scopedSlots:_vm._u([{key:"option",fn:function(ref){
var option = ref.option;
return [_vm._v(" "+_vm._s(option.text)+" ")]}},{key:"singleLabel",fn:function(ref){
var option = ref.option;
return [_vm._v(" "+_vm._s(option.text)+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }